<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Stack, Text, Token, Input, Collapse } from '@Shelly/shelly-design-system';

	export let value: number = 0;
	export let units: string = 'sec';

	const dispatch = createEventDispatcher<{
		change: { value: number; units: string };
	}>();

	function handleValueInput(e: Event) {
		const target = e.target as HTMLInputElement;
		const val = parseInt(target.value, 10);
		if (!isNaN(val) && val >= 0) {
			value = val;
			dispatch('change', { value, units });
		}
	}

	function setUnits(u: string) {
		units = u;
		dispatch('change', { value, units });
	}
</script>

<Collapse title={$format('flow_action_delay', { default: 'Delay before execution' })} id="delay-field">
	<Stack direction="row" gap="s">
		<div class="delay-row">
			<Input
				id="action-delay-value"
				type="number"
				value={String(value)}
				on:input={handleValueInput}
				min={0}
				max={1440}
				aria-label={$format('label_delay_value', { default: 'Delay value' })}
			/>
			<div class="units-toggle">
				<Token
					id="delay-unit-sec"
					title={$format('label_seconds_short', { default: 'Sec' })}
					selected={units === 'sec'}
					on:click={() => setUnits('sec')}
				/>
				<Token
					id="delay-unit-min"
					title={$format('label_minutes_short', { default: 'Min' })}
					selected={units === 'min'}
					on:click={() => setUnits('min')}
				/>
			</div>
		</div>
		<Text variant="body" size="xs" class="delay-help">
			{$format('flow_delay_help', {
				default: 'Set a delay before this action executes. Leave at 0 for immediate execution.',
			})}
		</Text>
	</Stack>
</Collapse>

<style>
	.delay-row {
		display: flex;
		gap: 8px;
		align-items: center;
	}

	.units-toggle {
		display: flex;
		gap: 4px;
		flex-shrink: 0;
	}

	:global(.delay-help) {
		color: #888 !important;
	}
</style>
